import * as React from "react";
import { Form, Button, Breadcrumb, Input, DatePicker, Radio } from "antd";
import "antd/dist/antd.css";
import { SendOutlined } from "@ant-design/icons";
import DataSource, {
  DATE_DISPLAY_FORMAT,
  DATE_SUBMIT_FORMAT,
} from "../lib/DataSource";
import { Link, RouteComponentProps } from "react-router-dom";

const { TextArea } = Input;

export default class AddFinanceRecord extends React.Component<
  { id: number; route: RouteComponentProps },
  {
    loading: boolean;
    student: any;
  }
> {
  contentType = "finance";

  constructor(props) {
    super(props);
    this.state = { loading: true, student: "" };
  }

  componentWillMount() {
    this.loadStudentData();
  }

  loadStudentData() {
    this.setState({ loading: true });
    DataSource.loadData("student", this.props.id).then((data) => {
      this.setState({ student: data, loading: false });
    });
  }

  handleSubmit(values) {
    if (values.date) {
      values.date = values.date.format(DATE_SUBMIT_FORMAT);
    }

    values.amount = parseFloat(values.amount);
    let url = "icd/finance/add-record/" + this.props.id;
    DataSource.submitData(url, values).then((result) => {
      this.props.route.history.push("/finance/records/" + this.props.id);
    });
  }

  render() {
    if (this.state.loading) {
      return <div className="loading"></div>;
    }

    let { student } = this.state;

    return (
      <div id="create-finance-record">
        <h2>Add a Finance Record</h2>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/finance/list">Fee</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={"/finance/records/" + this.props.id}>
              {this.state.student.firstname} {this.state.student.lastname}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Add</Breadcrumb.Item>
        </Breadcrumb>
        <Form
          className="icd-form"
          name="add-finance-record"
          onFinish={this.handleSubmit.bind(this)}
        >
          <Form.Item label="Student">
            {student.firstname} {student.lastname}({student.student_no})
          </Form.Item>
          <Form.Item label="Category" name="category">
            <Input />
          </Form.Item>
          <Form.Item label="Record Type" name="type" required={true}>
            <Radio.Group>
              <Radio value={1}>Fee</Radio>
              <Radio value={2}>Payment</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item label="Amount" name="amount">
            <Input type="number" />
          </Form.Item>
          <Form.Item label="Date" name="date">
            <DatePicker format={DATE_DISPLAY_FORMAT} />
          </Form.Item>
          <Form.Item label="Ref no" name="reference_no">
            <Input />
          </Form.Item>
          <Form.Item label="Comment" name="comment">
            <TextArea />
          </Form.Item>
          <Button type="primary" icon={<SendOutlined />} htmlType="submit">
            Add Record
          </Button>{" "}
          &nbsp;&nbsp;&nbsp;
          <Link to={"/finance/records/" + this.props.id}>Cancel</Link>
        </Form>
      </div>
    );
  }
}
